import React from 'react';
import ModuleContainer from '@/presentation/components/Container';
import ListCategory from './components/ListCategory';
import SectionHeader from '@/presentation/reusables/SectionHeader';

interface CoursesViewProps {
  handlerRedirect: any;
  courseSections: any;
  sectionHeader: any;
}

const CoursesView = ({
  handlerRedirect,
  courseSections = [],
  sectionHeader
}: CoursesViewProps) => (
  <ModuleContainer containerType="section">
    <SectionHeader
      title={sectionHeader.title}
      description={sectionHeader.description}
    />
    <ListCategory
      courseSections={courseSections}
      handleSelectCategory={handlerRedirect}
      testId="cmp-Category-list"
    />
  </ModuleContainer>
);
export default CoursesView;
